<template>
<div :ref="LoadingObj">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">续费设置详情</span>
        <div class="TTL-BTN-LIST">
            <wcbutton :option="{title:'返回续费设置管理',type:'del'}" class="left15" @finish="(val)=> {$parent.JUMPVIEW({name:'EsRenew'})}" />
        </div>
    </div>

    <div class="ttl-goods-table top40">
        <table border="1" style="border-collapse: collapse;border-spacing: 0;">
            <tr>
                <th width="20%" align="center">置顶名称</th>
                <th width="20%" align="center">作用区域</th>
                <th width="20%" align="center">置顶时间</th>
                <th width="20%" align="center">备注</th>
            </tr>
            <tr>
                <td align="center">{{renewinfo.name}}</td>
                <td align="center">{{renewinfo.area_type}}</td>
                <td align="center">{{renewinfo.timetype==1 ? renewinfo.nums+'日' : renewinfo.timetype==2 ? renewinfo.nums+'月' : renewinfo.nums+'年'}}</td>
                <td align="center">{{renewinfo.note}}</td>
            </tr>
            <tr>
                <th width="20%" align="center">已下单数量</th>
                <th width="20%" align="center">已支付金额</th>
                <th width="20%" align="center">充值金额</th>
                <th width="20%" align="center">/</th>
            </tr>
            <tr>
                <td align="center">{{renewinfo.orders}}</td>
                <td align="center">{{renewinfo.ordersprice}}</td>
                <td align="center">{{renewinfo.price}}</td>
                <td align="center">/</td>
            </tr>
        </table>
    </div>

    <div class="TTL-renew-detail top50">
        <span class="TTL-renew-title">置顶续费记录</span>
        <div class="TTL-table top30">
            <el-table :data="renewinfo.renewdetails" stripe="true" empty-text="" >
                <template v-slot:empty><el-empty description="暂无数据" /></template>
                <el-table-column label="置顶商品" align="center" min-width="150">
                    <template #default="scope">
                        <wcimage :option="{size:'middle'}" :value="scope.row.goodsthumb" />
                    </template>
                </el-table-column>
                <el-table-column label="置顶商品名称" align="center" min-width="150">
                    <template #default="scope">
                        <span>{{scope.row.goodsname}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="订阅金额" align="center" min-width="150"> 
                    <template #default="scope">
                        <span class="renew-price">{{'￥'+scope.row.price}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="area_type" label="作用区域" align="center" min-width="150" />
                <el-table-column label="首页订阅时间" align="center" min-width="150">
                    <template #default="scope">
                        <span>{{scope.row.idx_nums=='' ? '/' : scope.row.idx_nums}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="首页置顶时间" align="center" min-width="280">
                    <template #default="scope">
                        <span>{{scope.row.endtime=='' ? '/' : scope.row.begintime+' ~ '+ scope.row.endtime}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="列表订阅时间" align="center" min-width="150">
                    <template #default="scope">
                        <span>{{scope.row.list_num=='' ? '/' : scope.row.list_num}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="列表置顶时间" align="center" min-width="280">
                    <template #default="scope">
                        <span>{{scope.row.listtopend=='' ? '/' : scope.row.listtopbegin+' ~ '+scope.row.listtopend}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="transition_sn" label="原始微信支付单号" align="center" min-width="150"/>
                <el-table-column prop="inputtime" label="操作时间" align="center"  min-width="150"/>
            </el-table>
        </div>
    </div>
            
</div>


</template>

<script>
import INTERFACE_MODEL_RENEW from '@/Interface/Es/Renew';

export default {
    components:{},
    data() {
        return {
            LoadingObj:'RenewDetail',  //loading对象   
            renewinfo:{},
        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {  //兄弟组件跳转至当前组件时进行询问操作
                this.GetRenewDetail(data.param.id);

            }else if(data.reload) {  //浏览器重新刷新时执行的操作
                
            }else {
                this.GetRenewDetail(data.param.id);

            } 
        },


        //获取续费设置详情
        GetRenewDetail(id) {
            INTERFACE_MODEL_RENEW.GET_RENEW_DETAIL({id:id}).then((res) => {
                 if(res.status > 0) return false;
                 this.renewinfo=res.data;
                 console.log(this.renewinfo);
            });
        },


    },
}
</script>
<style scoped>
.ttl-goods {padding:20px 15px 50px 15px;width:calc(100% - 30px);}
.ttl-member-info {display: inline-flex;align-items: center;width:100%;font-size:0;}
.ttl-member-info i {font-style: normal;color:#666eeb;font-size:13px;cursor: pointer;}
.ttl-member-info .el-image {width:80px;height:80px;border-radius: 50%;box-shadow: 0 0 10px #dddddd;}
.ttl-member-info span {display: inline-flex;align-items: center;font-size:13px;color:#666666;}
.ttl-frozen {box-shadow: 0 !important;width:20px !important;height: 20px !important;}
.ttl-member-status {display: inline-flex;align-items: center;}

.ttl-goods-table {display:inline-block;width:100%;}
.ttl-goods-table table {width:100%;border-color: #EBEDF0;padding:0;}
.ttl-goods-table table th {background-color: #EBEDF0;}
.ttl-goods-table table th,.ttl-goods-table table td {padding:20px;font-size:13px;color:#333333;font-weight: normal;}
.ttl-goods-table .el-image {width:60px;height: 60px;border-radius: 50%;box-shadow: 0 0 10px #EBEDF0;}
.numbers {color:#666eeb;cursor: pointer;}
.TTL-renew-detail {display: inline-block;width:100%;}
.TTL-renew-title {display: inline-block;width:100%;font-size:16px;font-weight: 550;color:#666666;}
.check-goods {color:#666eeb;cursor: pointer;}
.renew-price {font-weight: bold;}
.er-time-status {display: inline-block;width:100%;text-align: center;}
</style>